// @flow

import titleCase from 'title-case';
import i18n from './i18n';

export default (str: string) => {
  return i18n.t(titleCase(str));
};
